<template lang="pug">
  
  MDashboardWidget( title="Links assigned to you for managing" )
    div( class="row" )
      div( class="col-12 text-right" )
        p Page {{ page }} of {{ lastPageNum }}
        span Per page:&nbsp;
        select( v-model="pageSize" )
          option( value="10" ) 10
          option( value="25" ) 25
          option( value="50" ) 50
          option( value="100" ) 100
        | &nbsp;
        div( class="btn-group" )
          button( class="btn btn-white" v-bind:disabled="page === 1" v-on:click="() => page -= 1" ) Prev page
          button( class="btn btn-white" v-bind:disabled="page === lastPageNum" v-on:click="() => page += 1" ) Next page
    
    div( class="ibox mt-4" )
      div(class="ibox-content")
        MRefreshQueryButton( v-bind:apollo-query="$apollo.queries.batchesPaginated" )
        span( v-if="$apollo.loading" ) Loading...
        table( v-else class="table table-striped" )
          thead
            th(class="text-center") Batch ID
            th(class="text-center") Name / Description
            th(class="text-center") Batch Date:
            th(class="text-center") No. of Audits:
            th(class="text-center") No. of links assigned to me
            th(class="text-center") No. of Resolved
            th(class="text-center") No. of Outstanding
            th

          tbody
            tr(v-for="batch in batchesPaginated.items" )
              td  
                | {{ batch.id }}
                br
                em Submitted by: {{ (batch.owner && batch.owner.name) || 'N/A' }}

              td( class="batch-name" )
                | {{ batch.name }}
                br
                em {{ batch.description }}

              td {{ dateFormat(batch.startedAt, 'dd/mm/yy HH:MM') }}

              td {{ batch.numLinks }}

              td
                router-link( target="_blank" v-bind:to="`/reporting/batches/${batch.id}/?user=${$moonpull.getCurrentUserSession().id}`" ) {{ batch.assignedToMeCount }}

              td
                router-link( target="_blank" v-bind:to="`/reporting/batches/${batch.id}/?status=resolved&user=${$moonpull.getCurrentUserSession().id}`" ) {{ batch.resolvedCount }}

              td
                router-link( target="_blank" v-bind:to="`/reporting/batches/${batch.id}/?status=outstanding&user=${$moonpull.getCurrentUserSession().id}`" ) {{ batch.outstandingCount }}

              td 
                router-link( class="btn btn-details btn-outline btn-info" v-bind:to="`/reporting/batches/${batch.id}`" target="_blank") Open Batch


</template>
<script>
import Vue from "vue";
import gql from "graphql-tag";
import * as dateFormat from "dateformat";
export default Vue.extend({
  data() {
    return {
      page: 1,
      pageSize: 10,
    };
  },

  apollo: {
    batchesPaginated: {
      query: gql`
        query ($page: Float!, $pageSize: Float!) {
          batchMany(
            filter: {
              deletedAt: {
                isNull: true
              }
            }
            assignedToMe: true
            page: $page
            perPage: $pageSize
            sort: { 
              startedAt: DESC
            }
          ) {
            count
            items {
              id
              owner {
                name
                email
                company {
                  name
                }
              }
              name
              description
              startedAt
              resolvedCount
              outstandingCount
              assignedToMeCount
              numLinks
            }
          }
        }
      `,
      variables() {
        return {
          page: Number(this.page),
          pageSize: Number(this.pageSize),
        };
      },
      update: (data) => data.batchMany,
    },
  },
  computed: {
    lastPageNum() {
      return this.batchesPaginated
        ? Math.ceil(this.batchesPaginated.count / this.pageSize)
        : "...";
    },
  },
  methods: {
    dateFormat,
  },
});
</script>